import { IBrowserIconsConstantsForOs, IBrowserIconsConstantsRect, IBrowserIconsConstantsSizes, IBrowserIconsConstantsText } from '../interfaces';

const CONSTANTS_ICON: IBrowserIconsConstantsSizes = { browserIconsSizes: [32], iconsPaddingBase: 0 };
const CONSTANTS_RECT: IBrowserIconsConstantsRect = { borderRadiusBase: 2.67 };
const CONSTANTS_TEXT: IBrowserIconsConstantsText = { textMaxWidthBase: 24, textFontSizeBase: 13.34, lineHeightRatio: 0.825 };

export const BROWSER_ICONS_CONSTANTS_FOR_WIN_11: IBrowserIconsConstantsForOs = { ...CONSTANTS_ICON, ...CONSTANTS_RECT, ...CONSTANTS_TEXT };
